import { useEffect, useRef } from 'react';

const useInitialRender = () => {
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }
  }, [initialRender]);

  return initialRender.current;
};

export default useInitialRender;
